// Store selected platforms - DECLARE AT TOP
let other_platforms = [];

async function validateForm() {
  let isValid = true;

  const fields = [
    { id: "first_name", errorId: "first_name_error" },
    { id: "last_name", errorId: "last_name_error" },
    { id: "phone", errorId: "phone_error" },
    { id: "email", errorId: "email_error" },
    // { id: "password", errorId: "password_error" },
    // { id: "confirm_password", errorId: "confirm_password_error" },
    { id: "country_id", errorId: "country_id_error" },
    { id: "company_name", errorId: "company_name_error" },
    { id: "company_address", errorId: "company_address_error" },
    { id: "seller_type_id", errorId: "seller_type_id_error" },
    { id: "no_of_products", errorId: "no_of_products_error" },
    { id: "have_stock", errorId: "have_stock_error" },
  ];

  // Validate required fields
  fields.forEach((field) => {
    const inputElement = document.getElementById(field.id);
    const errorElement = document.getElementById(field.errorId);

    if (!inputElement.value || inputElement.value.trim() === "") {
      errorElement.style.display = "block";
      isValid = false;
    } else {
      errorElement.style.display = "none";
    }
  });

  // Email validation
  const emailElement = document.getElementById("email");
  const emailErrorElement = document.getElementById("email_error");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailPattern.test(emailElement.value.trim())) {
    emailErrorElement.style.display = "block";
    emailErrorElement.innerText = "Please enter a valid email address.";
    isValid = false;
  } else {
    emailErrorElement.style.display = "none";
    
    // Check if email already exists
    try {
      const response = await fetch('https://pro.curiouz.com/api/is-email-valid', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: emailElement.value.trim() }),
      });

      const data = await response.json();

      if (!data.success) {
        emailErrorElement.style.display = "block";
        emailErrorElement.innerText = data.message || "Email is already registered.";
        isValid = false;
      } else {
        emailErrorElement.style.display = "none";
      }
    } catch (error) {
      console.error("Email validation error:", error);
      emailErrorElement.style.display = "block";
      emailErrorElement.innerText = "Error validating email.";
      isValid = false;
    }
  }

  // Phone number validation
  const phoneElement = document.getElementById("phone");
  const phoneErrorElement = document.getElementById("phone_error");
  const phoneCodeElement = document.querySelector('.iti__selected-dial-code');

  if (phoneElement.value.trim().length < 6) {
    phoneErrorElement.style.display = "block";
    phoneErrorElement.innerText = "Phone number must be at least 6 characters long.";
    isValid = false;
  } else if (!phoneCodeElement || !phoneCodeElement.innerHTML) {
    phoneErrorElement.style.display = "block";
    phoneErrorElement.innerText = "Please select a phone code.";
    isValid = false;
  } else {
    phoneErrorElement.style.display = "none";
  }

  // Password validation
//   const passwordElement = document.getElementById("password");
//   const confirmPasswordElement = document.getElementById("confirm_password");
//   const passwordErrorElement = document.getElementById("password_error");
//   const confirmPasswordErrorElement = document.getElementById("confirm_password_error");

//   const password = passwordElement.value.trim();
//   const confirmPassword = confirmPasswordElement.value.trim();
//   const specialCharPattern = /[!@#$%^&*(),._?":{}|<>]/;

//   if (password.length < 8 || !specialCharPattern.test(password)) {
//     passwordErrorElement.style.display = "block";
//     passwordErrorElement.innerText = "Password must be at least 8 characters long and contain at least one special character.";
//     isValid = false;
//   } else {
//     passwordErrorElement.style.display = "none";
//   }

//   if (password !== confirmPassword) {
//     confirmPasswordErrorElement.style.display = "block";
//     confirmPasswordErrorElement.innerText = "Passwords do not match.";
//     isValid = false;
//   } else {
//     confirmPasswordErrorElement.style.display = "none";
//   }

  return isValid;
}

function showToast(message, isSuccess) {
  const toastContainer = document.getElementById("toast-container");
  const toast = document.createElement("div");
  toast.className = "toast";
  toast.classList.add(isSuccess ? "toast-success" : "toast-error");

  const messageSpan = document.createElement("span");
  messageSpan.innerText = message;

  const closeButton = document.createElement("button");
  closeButton.className = "toast-close";
  closeButton.innerHTML = "&times;";
  closeButton.onclick = function () {
    toast.style.animation = "fadeOut 0.5s forwards";
    setTimeout(() => toastContainer.removeChild(toast), 500);
  };

  toast.appendChild(messageSpan);
  toast.appendChild(closeButton);
  toastContainer.appendChild(toast);

  toast.style.display = "flex";

  setTimeout(() => {
          // Close the modal
          const modal = document.getElementById('myModal');
          if (modal) {
            modal.style.display = 'none';
          }
          
          // Reset the form
          const form = document.getElementById('msform');
          if (form) {
            form.reset();
          }
          
          // Clear the other_platforms array
          other_platforms = [];
          
          // Clear selected items display
          const selectedItemsDiv = document.getElementById('selectedItems');
          if (selectedItemsDiv) {
            selectedItemsDiv.innerHTML = '';
          }
          
          // Reset dropdown items
          document.querySelectorAll('.dropdown-menu-item').forEach(item => {
            item.classList.remove('selected');
            item.style.display = 'block';
          });
          
          // Reset z-index
          document.querySelector('.shopify-section-header')?.style.setProperty('z-index', '9000', 'important');
          document.querySelector('.announcement-bar-static')?.style.setProperty('z-index', '135', 'important');
          document.querySelector('.modal2')?.style.setProperty('z-index', '0', 'important');
        }, 3000);
}

function showThankYouModal() {
  console.log('showThankYouModal called');
  
  const myModal = document.getElementById('myModal');
  const thankyouModal = document.getElementById('thankyouModal');
  
  console.log('myModal element:', myModal);
  console.log('thankyouModal element:', thankyouModal);
  
  // Hide the form modal
  if (myModal) {
    myModal.style.display = 'none';
    console.log('myModal hidden');
  }
  
  // Show thank you modal - apply all necessary styles
  if (thankyouModal) {
    thankyouModal.style.display = 'block';
    thankyouModal.style.position = 'fixed';
    thankyouModal.style.zIndex = '10000';
    thankyouModal.style.left = '0';
    thankyouModal.style.top = '0';
    thankyouModal.style.width = '100%';
    thankyouModal.style.height = '100%';
    thankyouModal.style.backgroundColor = 'rgba(0,0,0,0.4)';
    thankyouModal.style.overflow = 'auto';
    console.log('thankyouModal displayed');
  } else {
    console.error('thankyouModal element not found!');
  }
}

function submitForm(formData) {
  console.log('Submitting form with data:', formData);
  
  fetch('https://pro.curiouz.com/api/seller-registration', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      console.log('Response status:', response.status);
      return response.json();
    })
    .then((data) => {
      console.log('Backend response:', data);
      resetSubmitButton();

      // Check if submission failed
      if (data.success === false || data.error || data.errors) {
        console.log('Form submission failed');
        if (data.message) {
          showToast(data.message, false);
        } else if (data.errors) {
          const errorField = Object.keys(data.errors)[0];
          const errorMessage = data.errors[errorField][0];
          showToast(errorMessage, false);
        } else {
          showToast("An error occurred. Please try again.", false);
        }
      } else if (data.success === true || data.status === 201) {
        // Success - show toast message first
        console.log('Form submission successful');
        showToast("Application submitted successfully! Our team will contact you within 48 hours.", true);
        
        // Wait 3 seconds for toast to be visible, then show thank you modal
        setTimeout(() => {
          // showThankYouModal();
        }, 5000);
      } else {
        // Unexpected response format
        console.warn('Unexpected response format:', data);
        showToast("Form submitted, but received unexpected response.", false);
      }
    })
    .catch((error) => {
      console.error("Form submission error:", error);
      resetSubmitButton();
      showToast("An error occurred while submitting the form. Please try again.", false);
    });
}

function resetSubmitButton() {
  const submitBtn = document.querySelector('.action-button.submit');
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.style.opacity = '1';
    submitBtn.style.cursor = 'pointer';
  }
}

function thankyouClose() {
  const thankyouModal = document.getElementById('thankyouModal');
  if (thankyouModal) {
    thankyouModal.style.display = "none";
  }
}

// Form submission handler
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing form handler');
  console.log('Initial other_platforms:', other_platforms);
  
  const form = document.getElementById("msform");
  
  if (form) {
    console.log('Form found, attaching submit handler');
    
    form.addEventListener("submit", async function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      
      console.log('Form submit triggered');
      console.log('Current other_platforms value:', other_platforms);

      const submitBtn = this.querySelector('.action-button.submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.6';
        submitBtn.style.cursor = 'not-allowed';
      }

      const isValid = await validateForm();
      console.log('Validation result:', isValid);

      if (isValid) {
        // Get phone code
        const phoneCodeElement = document.querySelector('.iti__selected-dial-code');
        const phoneCode = phoneCodeElement ? phoneCodeElement.innerHTML.trim() : '';

        // Prepare form data according to backend structure
        const formData = {
          first_name: document.getElementById('first_name').value.trim(),
          last_name: document.getElementById('last_name').value.trim(),
          email: document.getElementById('email').value.trim(),
          // password: document.getElementById('password').value.trim(),
          phone_code: phoneCode,
          phone: document.getElementById('phone').value.trim(),
          country_id: parseInt(document.getElementById('country_id').value),
          company_name: document.getElementById('company_name').value.trim(),
          company_address: document.getElementById('company_address').value.trim(),
          seller_type_id: parseInt(document.getElementById('seller_type_id').value),
          other_platform: other_platforms, // This should now have the selected platforms
          main_url: document.getElementById('main_url').value.trim() || null,
          no_of_products: document.getElementById('no_of_products').value,
          social_links: document.getElementById('social_links').value.trim() || null,
          have_stock: document.getElementById('have_stock').value
        };

        console.log('Final formData being sent:', formData);
        console.log('other_platform array:', formData.other_platform);
        submitForm(formData);
      } else {
        console.log('Form validation failed');
        resetSubmitButton();
      }
    });
  } else {
    console.error('Form element not found!');
  }
});

// UPDATED: toggleItem function to properly add to other_platforms array
function toggleItem(element) {
  const itemText = element.innerText.trim();
  
  if (element.classList.contains('selected')) {
    // Remove selection
    element.classList.remove('selected');
    element.style.display = 'block';
    removeSelected(itemText);
  } else {
    // Add selection
    element.classList.add('selected');
    element.style.display = 'none';
    addToSelected(itemText);
    // Add to array if not already present
    if (!other_platforms.includes(itemText)) {
      other_platforms.push(itemText);
      console.log('Added to other_platforms:', itemText);
      console.log('Current other_platforms:', other_platforms);
    }
  }
}

function addToSelected(itemText) {
  const selectedItemsDiv = document.getElementById('selectedItems');
  const defaultText = document.getElementById('defaultText');
  
  const selectedItemDiv = document.createElement('div');
  selectedItemDiv.className = 'selected-item';
  selectedItemDiv.innerHTML = `${itemText} <span class="selected-item-delete" onclick="removeSelectedItem(event, this)">×</span>`;
  selectedItemsDiv.appendChild(selectedItemDiv);
  
  if (defaultText) {
    defaultText.style.display = 'none';
  }
}

function removeSelected(itemText) {
  const selectedItemsDiv = document.getElementById('selectedItems');
  const defaultText = document.getElementById('defaultText');
  
  const selectedItem = Array.from(selectedItemsDiv.getElementsByClassName('selected-item')).find((item) =>
    item.textContent.trim().startsWith(itemText)
  );
  
  if (selectedItem) {
    selectedItemsDiv.removeChild(selectedItem);
  }

  const menuItem = Array.from(document.querySelectorAll('.dropdown-menu-item')).find(
    (item) => item.textContent.trim() === itemText
  );
  
  if (menuItem) {
    menuItem.classList.remove('selected');
    menuItem.style.display = 'block';
  }
  
  // Remove from array
  const index = other_platforms.indexOf(itemText);
  if (index > -1) {
    other_platforms.splice(index, 1);
    console.log('Removed from other_platforms:', itemText);
    console.log('Current other_platforms:', other_platforms);
  }
  
  if (defaultText && selectedItemsDiv.children.length === 1) {
    defaultText.style.display = 'block';
  }
}

function removeSelectedItem(event, deleteButton) {
  event.stopPropagation();
  const selectedItem = deleteButton.parentNode;
  const itemText = selectedItem.textContent.replace('×', '').trim();
  removeSelected(itemText);
}

function toggleDropdown() {
  const dropdownMenu = document.getElementById('dropdownMenu');
  if (dropdownMenu) {
    dropdownMenu.classList.toggle('show');
  }
}

// Close dropdown when clicking outside
document.addEventListener('click', function (event) {
  const dropdownMenu = document.getElementById('dropdownMenu');
  const selectedItems = document.getElementById('selectedItems');

  if (dropdownMenu && selectedItems) {
    if (dropdownMenu.classList.contains('show')) {
      if (!dropdownMenu.contains(event.target) && !selectedItems.contains(event.target)) {
        dropdownMenu.classList.remove('show');
      }
    }
  }
});